/* eslint-disable */
/* jshint ignore:start */

export const HOME_TOPICS = [
  {
    title: '10 tips for choosing the perfect domain name',
    url: 'https://www.godaddy.com/garage/10-tips-for-choosing-the-perfect-domain-name/',
  },
  {
    title: 'How to start a website from A to Z: A 5-step guide',
    url: 'https://www.godaddy.com/garage/how-to-start-a-website-from-a-to-z/',
  },
  {
    title: '5 tried-and-true tips for buying and selling domain names for profit',
    url: 'https://www.godaddy.com/garage/5-tried-and-true-tips-for-buying-and-selling-domain-names-for-profit/',
  },
  {
    title: 'The top 25 most expensive domain names',
    url: 'https://www.godaddy.com/garage/the-top-20-most-expensive-domain-names/',
  },
  {
    title: 'You’ve registered a domain name. Now what?',
    url: 'https://www.godaddy.com/garage/youve-registered-domain-name-now/',
  },
  {
    title: 'How to buy a domain that someone else owns',
    url: 'https://www.godaddy.com/garage/how-to-buy-a-domain-that-someone-else-owns/',
  },
  {
    title: 'GoDaddy SmartLine: Your business deserves its own phone number',
    url: 'https://www.godaddy.com/garage/godaddy-smartline-your-business-deserves-its-own-phone-number/',
  },
  {
    title: 'How much does a domain name cost?',
    url: 'https://www.godaddy.com/garage/how-much-domain-name-cost/',
  },
];
